export const Topwear = [
	{
		title: 'T-Shirts',
		url: '#',
	},
	{
		title: 'Casual Shirts',
		url: '#',
	},
	{
		title: 'Formal Shirts',
		url: '#',
	},
	{
		title: 'Sweatshirts',
		url: '#',
	},
	{
		title: 'Sweaters',
		url: '#',
	},
	{
		title: 'Jackets',
		url: '#',
	},
	{
		title: 'Blazers & Coats',
		url: '#',
	},
	{
		title: 'Suits',
		url: '#Rain Jackets',
	},
];

export const indian_festive = [
	{
		title: 'Kurtas & Kurta Sets',
		url: '#',
	},
	{
		title: 'Sherwanis',
		url: '#',
	},
	{
		title: 'Nehru Jackets',
		url: '#',
	},
	{
		title: 'Dhotis',
		url: '#',
	},
];

export const bottomwear = [
	{
		title: 'Jeans',
		url: '#',
	},
	{
		title: 'Casual Trousers',
		url: '#',
	},
	{
		title: 'Formal Trousers',
		url: '#',
	},
	{
		title: 'Shorts',
		url: '#',
	},
	{
		title: 'Track Pants & Joggers',
		url: '#',
	},
];

export const Innerwear_Sleepwear = [
	{
		title: 'Briefs & Trunks',
		url: '#',
	},
	{
		title: 'Boxers',
		url: '#',
	},
	{
		title: 'Vests',
		url: '#',
	},
	{
		title: 'Sleepwear & Loungewear',
		url: '#',
	},
	{
		title: 'Thermals',
		url: '#',
	},
];

export const Footwear = [
	{
		title: 'Casual Shoes',
		url: '#',
	},
	{
		title: 'Sports Shoes',
		url: '#',
	},
	{
		title: 'Formal Shoes',
		url: '#',
	},
	{
		title: 'Sneakers',
		url: '#',
	},
	{
		title: 'Sandals & Floaters',
		url: '#',
	},
	{
		title: 'Flip Flops',
		url: '#',
	},
	{
		title: 'Socks',
		url: '#',
	},
];

export const Sports_Active_Wear = [
	{
		title: 'Sports Shoes',
		url: '#',
	},
	{
		title: 'Sports Sandals',
		url: '#',
	},
	{
		title: 'Active T-Shirts',
		url: '#',
	},
	{
		title: 'Track Pants & Shorts',
		url: '#',
	},
	{
		title: 'Tracksuits',
		url: '#',
	},
	{
		title: 'Jackets & Sweatshirts',
		url: '#',
	},
	{
		title: 'Sports Accessories',
		url: '#',
	},
	{
		title: 'Swimwear',
		url: '#',
	},
];

export const Gadgets = [
	{
		title: 'Smart Wearables',
		url: '#',
	},
	{
		title: 'Fitness Gadgets',
		url: '#',
	},
	{
		title: 'Headphones',
		url: '#',
	},
	{
		title: 'Speakers',
		url: '#',
	},
];

export const Fashion_Accessories = [
	{
		title: 'Wallets',
		url: '#',
	},
	{
		title: 'Belts',
		url: '#',
	},
	{
		title: 'Perfumes & Body Mists',
		url: '#',
	},
	{
		title: 'Trimmers',
		url: '#',
	},
	{
		title: 'Deodorants',
		url: '#',
	},
	{
		title: 'Ties, Cufflinks & Pocket Squares',
		url: '#',
	},
	{
		title: 'Accessory Gift Sets',
		url: '#',
	},
	{
		title: 'Caps & Hats',
		url: '#',
	},
	{
		title: 'Mufflers, Scarves & Gloves',
		url: '#',
	},
	{
		title: 'Phone Cases',
		url: '#',
	},
	{
		title: 'Rings & Wristwear',
		url: '#',
	},
	{
		title: 'Helmets',
		url: '#',
	},
];

// *************************************Women****************************************

export const Indian_FusionWear = [
	{
		title: 'B2C White Label Travel Website',
		url: '/b2c-white-label',
	},
	{
		title: 'B2B White Label Travel Website',
		url: '/b2b-white-label',
	},
	{
		title: 'B2B2B White Label Travel Website',
		url: '/b2b2b-white-label',
	},
];

export const Western_Wear = [
	{
		title: 'Amadeus API Integration',
		url: '/amadeus-api-integration',
	},
	{
		title: 'Galileo API Integration',
		url: '/galileo-api-integration',
	},
	{
		title: 'Sabre API Integration',
		url: '/sabre-api-integration',
	},
];

export const Shop_Occassion = [
	{
		title: 'Travel Android Application Development',
		url: '/travel-portal-android-mobile-app',
	},
	{
		title: 'Travel IOS Application Development',
		url: '/travel-portal-ios-mobile-app',
	},
	{
		title: 'Travel Portal Windows Mobile App',
		url: '/travel-portal-window-mobile-app',
	},
];

export const WFootwear = [
	{
		title: 'Travel CRM',
		url: '/travel-crm',
	},
	{
		title: 'B2C Travel Portal',
		url: '/b2c-travel-portal',
	},
	{
		title: 'B2B Travel Portal',
		url: '/b2b-travel-portal',
	},
	{
		title: 'B2E Travel Portal',
		url: '/b2e-travel-portal',
	},
	{
		title: 'B2B2B Travel Portal',
		url: '/b2b2b-travel-portal',
	},
	{
		title: 'Tour Package Website',
		url: '/tour-package-system',
	},
	{
		title: 'Flight Booking Software',
		url: '/flight-booking-system',
	},
	{
		title: 'Hotel Booking Software',
		url: '/hotel-booking-system',
	},
	{
		title: 'Bus Booking Software',
		url: '/bus-and-car-booking-system',
	},
	{
		title: 'Tour Operator Software',
		url: '/tour-operator-software',
	},
	{
		title: 'Software for Travel Agency',
		url: '/software-for-travel-agency',
	},
];

export const Sports_ActiveWear = [
	{
		title: 'Travel APIs',
		url: '/travel-apis',
	},
	{
		title: 'Travel API Integration',
		url: '/travel-api-integration',
	},
	{
		title: 'Flight API Integration',
		url: '/flight-api-integration',
	},
	{
		title: 'Hotel API Integration',
		url: '/hotel-api-integration',
	},
	{
		title: 'Bus/Car API Integration',
		url: '/bus-and-car-api-integration',
	},
];

export const Lingerie_Sleepwear = [
	{
		title: 'Flight Extranet',
		url: '/flight-extranet-system',
	},
	{
		title: 'Hotel Extranet',
		url: '/hotel-extranet-system',
	},
	{
		title: 'Tour Package Extranet',
		url: '/tour-package-extranet',
	},
];
export const Beauty_Personal_Care = [
	{
		title: 'Makeup',
		url: '#',
	},
	{
		title: 'Skincare',
		url: '#',
	},
	{
		title: 'Premium Beauty',
		url: '#',
	},
	{
		title: 'Lipsticks',
		url: '#',
	},
	{
		title: 'Fragrances',
		url: '#',
	},
];

// ************************************************************Kids******************************
export const Boys_Clothing = [
	{
		title: 'B2C E commerce Website Development',
		url: '/b2c-ecommerce-website-development',
	},
	{
		title: 'B2B E commerce Website Development',
		url: '/b2b-ecommerce-website-development',
	},
	{
		title: 'Vendor / Supplier Module',
		url: '/vendor-module-development',
	},
	{
		title: 'Deliver Boy Module',
		url: '/delivery-person-module-development',
	},
];

export const Girls_Clothing = [
	{
		title: 'E-commerce Android Mobile App ',
		url: '/ecommerce-module-android-mobile-app',
	},
	{
		title: 'E-Commerce iOS Mobile App',
		url: '/ecommerce-module-ios-mobile-app',
	},
];

export const KFootwear = [
	{
		title: 'Casual Shoes',
		url: '#',
	},
	{
		title: 'Flipflops',
		url: '#',
	},
	{
		title: 'Sports Shoes',
		url: '#',
	},
	{
		title: 'Flats',
		url: '#',
	},
	{
		title: 'Sandals',
		url: '#',
	},
	{
		title: 'Heels',
		url: '#',
	},
	{
		title: 'School Shoes',
		url: '#',
	},
	{
		title: 'Socks',
		url: '#',
	},
];

export const Toys = [
	{
		title: 'Learning & Development',
		url: '#',
	},
	{
		title: 'Activity Toys',
		url: '#',
	},
	{
		title: 'Soft Toys',
		url: '#',
	},
	{
		title: 'Action Figure / Play set',
		url: '#',
	},
];

export const Infants = [
	{
		title: 'Bodysuits',
		url: '#',
	},
	{
		title: 'Rompers & Sleepsuits',
		url: '#',
	},
	{
		title: 'Clothing Sets',
		url: '#',
	},
	{
		title: 'Tshirts & Tops',
		url: '#',
	},
	{
		title: 'Dresses',
		url: '#',
	},
	{
		title: 'Bottom wear',
		url: '#',
	},
	{
		title: 'Winter Wear',
		url: '#',
	},
	{
		title: 'Innerwear & Sleepwear',
		url: '#',
	},
	{
		title: 'Infant Care',
		url: '#',
	},
];

export const Kids_Accessories = [
	{
		title: 'Bags & Backpacks',
		url: '#',
	},
	{
		title: 'Watches',
		url: '#',
	},
	{
		title: 'Jewellery & Hair accessory',
		url: '#',
	},
	{
		title: 'Sunglasses',
		url: '#',
	},
	{
		title: 'Masks & Protective Gears',
		url: '#',
	},
	{
		title: 'Caps & Hats',
		url: '#',
	},
];

export const KBrands = [
	{
		title: 'H&M',
		url: '#',
	},
	{
		title: 'Max Kids',
		url: '#',
	},
	{
		title: 'Pantaloons',
		url: '#',
	},
	{
		title: 'United Colors Of Benetton Kids',
		url: '#',
	},
	{
		title: 'YK',
		url: '#',
	},
	{
		title: 'U.S. Polo Assn. Kids',
		url: '#',
	},
	{
		title: 'Mothercare',
		url: '#',
	},
];

// *********************************Home & Living ********************************

export const BedLinenFurnishing = [
	{
		title: 'Bedsheets',
		url: '#',
	},

	{
		title: 'Bedding Sets',
		url: '#',
	},
	{
		title: 'Blankets, Quilts & Dohars',
		url: '#',
	},
	{
		title: 'Pillows & Pillow Covers',
		url: '#',
	},
	{
		title: 'Bed Covers',
		url: '#',
	},
	{
		title: 'Diwan Sets',
		url: '#',
	},
	{
		title: 'Chair Pads & Covers',
		url: '#',
	},
	{
		title: 'Sofa Covers',
		url: '#',
	},
];

export const Flooring = [
	{
		title: 'Carpets',
		url: '#',
	},
	{
		title: 'Floor Mats & Dhurries',
		url: '#',
	},
	{
		title: 'Door Mats',
		url: '#',
	},
];
export const Bath = [
	{
		title: 'Bath Towels',
		url: '#',
	},

	{
		title: 'Hand & Face Towels',
		url: '#',
	},
	{
		title: 'Beach Towels',
		url: '#',
	},
	{
		title: 'Towels Set',
		url: '#',
	},
	{
		title: 'Bath Rugs',
		url: '#',
	},
	{
		title: 'Bath Robes',
		url: '#',
	},
	{
		title: 'Bathroom Accessories',
		url: '#',
	},
	{
		title: 'Shower Curtains',
		url: '#',
	},
];
export const LampsLighting = [
	{
		title: 'Floor Lamps',
		url: '#',
	},

	{
		title: 'Ceiling Lamps',
		url: '#',
	},
	{
		title: 'Table Lamps',
		url: '#',
	},
	{
		title: 'Wall Lamps',
		url: '#',
	},
	{
		title: 'Outdoor Lamps',
		url: '#',
	},
	{
		title: 'String Lights',
		url: '#',
	},
];
export const HomeDécor = [
	{
		title: 'Plants & Planters',
		url: '#',
	},

	{
		title: 'Aromas & Candles',
		url: '#',
	},
	{
		title: 'Clocks',
		url: '#',
	},
	{
		title: 'Mirrors',
		url: '#',
	},
	{
		title: 'Wall Décor',
		url: '#',
	},
	{
		title: 'Festive Decor',
		url: '#',
	},
	{
		title: 'Pooja Essentials',
		url: '#',
	},
	{
		title: 'Wall Shelves',
		url: '#',
	},
	{
		title: 'Fountains',
		url: '#',
	},
	{
		title: 'Showpieces & Vases',
		url: '#',
	},
];
export const KitchenTable = [
	{
		title: 'Dinnerware & Serveware',
		url: '#',
	},

	{
		title: 'Cups and Mugs',
		url: '#',
	},
	{
		title: 'Bakeware & Cookware',
		url: '#',
	},
	{
		title: 'Kitchen Storage & Tools',
		url: '#',
	},
	{
		title: 'Bar & Drinkware',
		url: '#',
	},
	{
		title: 'Table Covers & Furnishings',
		url: '#',
	},
];
export const Storage = [
	{
		title: 'Organisers',
		url: '#',
	},
	{
		title: 'Hooks & Holders',
		url: '#',
	},
	{
		title: 'Laundry Bags',
		url: '#',
	},
];
export const HBrands = [
	{
		title: 'Home Centre',
		url: '#',
	},
	{
		title: 'Spaces',
		url: '#',
	},
	{
		title: 'D Decor',
		url: '#',
	},
	{
		title: 'Portico New York',
		url: '#',
	},
	{
		title: 'Story@Home',
		url: '#',
	},
	{
		title: 'Pure Home & Living',
		url: '#',
	},
	{
		title: 'Swayam',
		url: '#',
	},
	{
		title: 'Raymond Home',
		url: '#',
	},
	{
		title: 'Maspar',
		url: '#',
	},
	{
		title: 'Corelle',
		url: '#',
	},
	{
		title: 'Trident',
		url: '#',
	},
	{
		title: 'Cortina',
		url: '#',
	},
	{
		title: 'Random',
		url: '#',
	},
	{
		title: 'Ellementry',
		url: '#',
	},
	{
		title: 'ROMEE',
		url: '#',
	},
	{
		title: 'SEJ by Nisha Gupta',
		url: '#',
	},
];

//*********************************************Beauty****************************

export const Makeup = [
	{
		title: 'Lipstick',
		url: '#',
	},
	{
		title: 'Lip Gloss',
		url: '#',
	},
	{
		title: 'Lip Liner',
		url: '#',
	},
	{
		title: 'Mascara',
		url: '#',
	},
	{
		title: 'Eyeliner',
		url: '#',
	},
	{
		title: 'Kajal',
		url: '#',
	},
	{
		title: 'Eyeshadow',
		url: '#',
	},
	{
		title: 'Foundation',
		url: '#',
	},
	{
		title: 'Primer',
		url: '#',
	},
	{
		title: 'Concealer',
		url: '#',
	},
	{
		title: 'Compact',
		url: '#',
	},
	{
		title: 'Nail Polish',
		url: '#',
	},
];

export const SkincareBathBody = [
	{
		title: 'Face Moisturiser',
		url: '#',
	},
	{
		title: 'Cleanser',
		url: '#',
	},
	{
		title: 'Masks & Peel',
		url: '#',
	},
	{
		title: 'Sunscreen',
		url: '#',
	},
	{
		title: 'Serum',
		url: '#',
	},
	{
		title: 'Face Wash',
		url: '#',
	},
	{
		title: 'Eye Cream',
		url: '#',
	},
	{
		title: 'Lip Balm',
		url: '#',
	},
	{
		title: 'Body Lotion',
		url: '#',
	},
	{
		title: 'Body Wash',
		url: '#',
	},
	{
		title: 'Body Scrub',
		url: '#',
	},
	{
		title: 'Hand Cream',
		url: '#',
	},
];

export const Haircare = [
	{
		title: 'Shampoo',
		url: '#',
	},
	{
		title: 'Conditioner',
		url: '#',
	},
	{
		title: 'Hair Cream',
		url: '#',
	},
	{
		title: 'Hair Oil',
		url: '#',
	},
	{
		title: 'Hair Gel',
		url: '#',
	},
	{
		title: 'Hair Color',
		url: '#',
	},
	{
		title: 'Hair Serum',
		url: '#',
	},
	{
		title: 'Hair Accessory',
		url: '#',
	},
];

export const Fragrances = [
	{
		title: 'Perfume',
		url: '#',
	},
	{
		title: 'Deodorant',
		url: '#',
	},
	{
		title: 'Body Mist',
		url: '#',
	},
	{
		title: 'Appliances',
		url: '#',
	},
];

export const HairStraightener = [
	{
		title: 'Hair Dryer',
		url: '#',
	},
	{
		title: 'Epilator',
		url: '#',
	},
];

export const MenGrooming = [
	{
		title: 'Trimmers',
		url: '#',
	},
	{
		title: 'Beard Oil',
		url: '#',
	},
	{
		title: 'Hair Wax',
		url: '#',
	},
];

export const BeautyGiftMakeupSet = [
	{
		title: 'Beauty Gift',
		url: '#',
	},
	{
		title: 'Makeup Kit',
		url: '#',
	},
];

export const BTopBrands = [
	{
		title: 'Lakme',
		url: '#',
	},
	{
		title: 'Maybelline',
		url: '#',
	},
	{
		title: 'LOreal',
		url: '#',
	},
	{
		title: 'Philips',
		url: '#',
	},
	{
		title: 'Bath & Body Works',
		url: '#',
	},
	{
		title: 'THE BODY SHOP',
		url: '#',
	},
	{
		title: 'Biotique',
		url: '#',
	},
	{
		title: 'Mamaearth',
		url: '#',
	},
	{
		title: 'MCaffeine',
		url: '#',
	},
	{
		title: 'Nivea',
		url: '#',
	},
	{
		title: 'Lotus Herbals',
		url: '#',
	},
	{
		title: 'LOreal Professionnel',
		url: '#',
	},
	{
		title: 'KAMA AYURVEDA',
		url: '#',
	},
	{
		title: 'M.A.C',
		url: '#',
	},
	{
		title: 'Forest Essentials',
		url: '#',
	},
];
